import { bio } from "./constType";

export const BioArray: bio[] = [
  {
    date: '2013年04月',
    org1: '宮崎県立宮崎西高等学校',
    org2: '普通科',
    status: '入学'
  },
  {
    date: '2016年03月',
    org1: '宮崎県立宮崎西高等学校',
    org2: '普通科',
    status: '卒業'
  },
  {
    date: '2016年04月',
    org1: '中央大学',
    org2: '経済学部',
    org3: '経済情報システム学科',
    status: '入学'
  },
  {
    date: '2020年03月',
    org1: '中央大学',
    org2: '経済学部',
    org3: '経済情報システム学科',
    status: '卒業'
  },
  {
    date: '2020年04月',
    org1: '現職',
    status: '入社'
  },
  {
    date: '2022年11月',
    org1: '現職',
    status: '在籍'
  }
]